var currentStep = 1;
var addressType = null;

$('#step1').hide();
$('#step2').hide();
$('#step3').hide();
step(startStep, false);

function PostcodeSelect() {
    var data = getFullAddress($('#addressDialog').find(':selected').val());
    $("#addressDialog").dialog("close");

    var address = '';
    if (addressType === 'postal') {
        address = '#PostalAddress_';
        $('#postalDetails').show();
    } else {
        address = '#InvoiceAddress_';
        $('#invoiceDetails').show();
    }

    $(address + 'Address1').val(data.FirstAddressLine);
    $(address + 'Address2').val(data.Address2);
    $(address + 'Address3').val(data.Address3);
    $(address + 'Address4').val(data.Town);
    $(address + 'Address5').val(data.County);
    $(address + 'Postcode').val(data.Postcode);
}

function step(step, validate) {
    var form = $('#register-form');

    if (validate === true) {
        form.removeData('validator').removeData('unobtrusiveValidation');
        $.validator.unobtrusive.parse($(form));
    }

    if ($('#register-form').valid() || !validate) {
        $('#step' + currentStep).hide();
        $('#step' + step).show();
        currentStep = step;
        if (currentStep === 2) {
            $('#PostalAddress_Postcode').focus();
        } else if (currentStep === 3) {
            $('#UserName').focus();
        }
    }
}

$('#postalLookup').click(function () {
    addressType = 'postal';
    getAddress($('#PostalAddress_Postcode').val());
});

$('#invoiceLookup').click(function () {
    addressType = 'invoice';
    getAddress($('#InvoiceAddress_Postcode').val());
});

$('#postalManual').click(function () {
    $('#postalDetails').show();
});

$('#invoiceManual').click(function () {
    $('#invoiceDetails').show();
});

$('#sameAddress').click(function () {
    $('#invoiceDetails').show();
    ['Address1', 'Address2', 'Address3', 'Address4', 'Address5', 'Postcode'].forEach(function (input) {
        $('#InvoiceAddress_' + input).val($('#PostalAddress_' + input).val());
    });
});

$(function () {
    if ($('#InvoiceAddress_Address1').val() !== '')
        $('#invoiceDetails').show();

    if ($('#PostalAddress_Address1').val() !== '')
        $('#postalDetails').show();

    // extend jquery range validator to work for required checkboxes
    var defaultRangeValidator = $.validator.methods.range;
    $.validator.methods.range = function (value, element, param) {
        if (element.type === 'checkbox') {
            // if it's a checkbox return true if it is checked
            return element.checked;
        } else {
            // otherwise run the default validation function
            return defaultRangeValidator.call(this, value, element, param);
        }
    };

    $.validator.methods._required = $.validator.methods.required;
    $.validator.methods.required = function (value, element, param) {
        if ($(element).is('[remote-validator]') && !$(element).hasClass('required'))
            return true;
        return $.validator.methods._required.call(this, value, element, param);
    }
});
